import * as React from "react";
import { observer } from "mobx-react-lite";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { DateTime } from "luxon";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import { useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MailOutline from "@material-ui/icons/MailOutline";
import Edit from "@material-ui/icons/Edit";
import { useHistory } from "react-router-dom";
import { UserRoleRuEnum, UserRoleEnum } from "../../../../static/enums/UserRole";
import { User } from "../../../../api/typings/Users";
import { Profiles, ParentProfile } from "../../../../api/typings/Profiles";
import { tableStore } from "../../../../mobx/stores/TableStore/TableStore";
import { DialogAutoLoginMail } from "../../../../components/DialogWindow/DialogAutoLoginMail/DialogAutoLoginMail";
import { Routes } from "../../../../routes/routes";

interface ParentProfilesTableRowProps {
  user: User;
}

function parentsFilter(profile: Profiles): profile is ParentProfile {
  return profile.role === UserRoleEnum.parent;
}

export const ParentsProfilesTableRow = observer(({ user }: ParentProfilesTableRowProps) => {
  const { usersProfiles, usersProfilesParents } = tableStore;
  const profilesParents = (Object.values(usersProfiles) as Profiles[]).filter(parentsFilter);
  const profilesId = user.profiles.map((profile) => profile.id);
  const profileInfo = profilesParents.find((profile) => profilesId.some((id) => profile.id === id));
  if (!profileInfo) return null;
  const parentInfo = usersProfilesParents[profileInfo.parent.id];
  const [open, setOpen] = useState(false);
  const history = useHistory();

  return (
    <TableRow hover>
      <TableCell>{user.id}</TableCell>
      <TableCell>
        {user.firstname} {user.lastname}
      </TableCell>
      <TableCell>{UserRoleRuEnum[profileInfo.role]}</TableCell>
      <TableCell>{DateTime.fromISO(profileInfo.created_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
      <TableCell>{DateTime.fromISO(profileInfo.updated_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
      <TableCell align={"center"}>
        {parentInfo.is_expired_subscription_payment_allowed ? (
          <Check color={"primary"} />
        ) : (
          <Close color={"secondary"} />
        )}
      </TableCell>
      <TableCell align={"right"}>
        <Tooltip title={<Typography variant={"caption"}>Редактировать</Typography>}>
          <IconButton onClick={() => handleUserInfo(user.id)}>
            <Edit color={"secondary"} fontSize={"small"} />
          </IconButton>
        </Tooltip>
        <Tooltip title={<Typography variant={"caption"}>Отправка ссылки на вход</Typography>}>
          <IconButton onClick={() => setOpen(true)}>
            <MailOutline fontSize={"small"} color={"secondary"} />
          </IconButton>
        </Tooltip>
      </TableCell>
      <DialogAutoLoginMail onClose={() => setOpen(false)} open={open} userId={user.id} />
    </TableRow>
  );

  function handleUserInfo(id: string): void {
    history.push(`/${Routes.user}/${id}`);
  }
});
